import type { ReactNode } from 'react';
import { can, type Capability } from '../lib/roles';
import { useApp } from '../state/AppContext';

const REASONS: Record<Capability, string> = {
  manageUsers: 'managing users',
  resetPassword: 'resetting passwords',
  setPassword: 'setting passwords',
  deleteUsers: 'deleting users',
  manageGrants: 'granting and revoking access',
  viewSystems: 'the connected systems',
  viewAudit: 'the audit log',
  viewEvents: 'the Keycloak event stream',
};

export function RequireCapability({
  capability,
  children,
}: {
  capability: Capability;
  children: ReactNode;
}) {
  const { me } = useApp();
  if (!can(me.clientRole, capability)) {
    return (
      <div className="page">
        <div className="error-banner">
          Access denied — your UDB role does not cover {REASONS[capability]}.
        </div>
      </div>
    );
  }
  return <>{children}</>;
}
